// A storage adapter that prefers localStorage, but is safe in React Native WebView environments.
// If a React Native WebView bridge is available, we optionally postMessage so the host app can mirror state.

export const nativeAwareStorage = {
  getItem: (name) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(name);
      }
    } catch (_) {}
    return null;
  },
  setItem: (name, value) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(name, value);
      }
      // Notify RN WebView host if available (no-op if not handled natively)
      if (typeof window !== 'undefined' && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'ZUSTAND_PERSIST_SET', key: name, value })
        );
      }
    } catch (_) {}
  },
  removeItem: (name) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(name);
      }
      if (typeof window !== 'undefined' && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'ZUSTAND_PERSIST_REMOVE', key: name })
        );
      }
    } catch (_) {}
  },
};


